export default "__VITE_ASSET__2a1b060f__"